import styled from 'styled-components';

export const StyledMedicalLeaveFormSection = styled.div`
   display: flex;
   flex-direction: column;
   gap: 24px;
`;
